const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'ritage',
    label: 'report.fields.ritage',
    header: 'ritage',
    filter: false,
    width: 30,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'ritageName',
    label: 'report.fields.ritageName',
    header: 'ritageName',
    filter: false,
    width: 30,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'ritageName',
    label: 'report.fields.ritageName',
    header: 'ritageName',
    filter: false,
    width: 30,
    headerRowspan: 2,
  },
  {
    key: 'depart',
    label: 'report.fields.depart',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'routeDepart',
        label: 'report.fields.route',
        header: 'routeDepart',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 1,
        isLocked: true,
      },
      {
        key: 'locationDepart',
        label: 'report.fields.location',
        header: 'locationDepart',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'startTimeDepart',
        label: 'report.fields.startRitage',
        header: 'startTimeDepart',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'endTimeDepart',
        label: 'report.fields.endRitage',
        header: 'endTimeDepart',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'mileageDepart',
        label: 'KM',
        header: 'mileageDepart',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
        isLocked: true,
      },
    ],
    headerColspan: 5,
  },
  {
    key: 'return',
    label: 'report.fields.return',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'routeReturn',
        label: 'report.fields.route',
        header: 'routeReturn',
        headerColspan: 1,
        childOfIndex: 1,
        isTopHead: 1,
        isLocked: true,
      },
      {
        key: 'locationReturn',
        label: 'report.fields.location',
        header: 'locationReturn',
        headerColspan: 1,
        childOfIndex: 1,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'startTimeReturn',
        label: 'report.fields.startRitage',
        header: 'startTimeReturn',
        headerColspan: 1,
        childOfIndex: 1,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'endTimeReturn',
        label: 'report.fields.endRitage',
        header: 'endTimeReturn',
        headerColspan: 1,
        childOfIndex: 1,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'mileageReturn',
        label: 'KM',
        header: 'mileageReturn',
        headerColspan: 1,
        childOfIndex: 1,
        isTopHead: 0,
        isLocked: true,
      },
      {
        key: 'mileageReturn',
        label: 'KM',
        header: 'mileageReturn',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
      },
    ],
    headerColspan: 5,
  },
  {
    key: 'totalMileage',
    label: 'Total KM',
    header: 'totalMileage',
    filter: false,
    width: 10,
    headerRowspan: 2,
    isLocked: true,
  },
]
export default fields
